// @flow

import type {EventRule, EventRuleChange, Language} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {toggleActive} from '@/rules-helper'
import RenderComplexRuleName from './complex-rule-name'
import InfoAlert from '@/elements/info-alert'
import {appSelectors} from '@/store'

type Props = {
  raiseChange: (EventRuleChange) => void,
  rule: EventRule,
  tooltip?: Array<string>,
  alert?: string,
  l: Language,
}

export const RawRatingValueChange = (props: Props) =>
  <div className="rating checkbox">
    <label>
      <input
        type="checkbox"
        onChange={() => props.raiseChange({
          ruleCode: props.rule.ruleCode,
          prop: 'isActive',
          val: toggleActive(props.rule),
          check: false,
        })}
        checked={props.rule.isActive}
        title={props.tooltip && props.tooltip[0]}
      />
    </label>
    <div className='complex-rule-name'>
      <RenderComplexRuleName {...props} />
    </div>
    {props.alert ? <InfoAlert isWarn={true} alertText={props.alert} l={props.l} /> : null}
  </div>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawRatingValueChange)



// WEBPACK FOOTER //
// ./src/views/settings-page/rules/rating-value-change.js